import * as BaggageCard from './components/BaggageCard.css';
export default {
    BaggageCard
};
